import { BASE_V2_URL } from 'constants/api';
import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'CURRICULUM_SEARCH_GET_ALL',
  GET_ALL_SUCCESS: 'CURRICULUM_SEARCH_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'CURRICULUM_SEARCH_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(
  query => `${BASE_V2_URL}/practice-sheets/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);
